import { fetchStocks } from "./inventoryAction";
import { formatData, sortByDateReverse } from "./utils";

export function fetchCommercialReas(){
    console.log("FIRED ACTION FETCH COMMERCIAL_REAS" )
    return async function(dispatch){
        dispatch({ type: "FETCH_COMMERCIAL_REAS_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/list',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const realist = await response.json()
            console.log(realist)// realist returns new object created

            if(!realist.error){ // no errors, return new Object
                dispatch({ type: "GET_COMMERCIAL_REAS", payload: formatData(sortByDateReverse(realist)) })
                dispatch({ type: "FETCH_COMMERCIAL_REAS_FULFILLED", payload:"" })
                console.log("realist fetched")
            
            } else {
                dispatch({
                    type: "FETCH_COMMERCIAL_REAS_ERROR",
                    payload: realist.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_COMMERCIAL_REAS_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchCommercialStocks(){
    console.log("FIRED ACTION FETCH COMMERCIAL_STOCKS" )
    return async function(dispatch){
        dispatch({ type: "FETCH_COMMERCIAL_STOCKS_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/stockList',{
                method:'GET',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            }); 
            
            const list = await response.json()
            console.log(list)// list returns new object created

            if(!list.error){ // no errors, return new Object
                // formatAgentStock
                let agentStock = {}
                list.forEach(stock => {
                    if (!agentStock[stock.commercial_id]){
                        agentStock[stock.commercial_id] = []
                    }
                    agentStock[stock.commercial_id].push(stock)
                })
                dispatch({ type: "GET_COMMERCIAL_STOCKS", payload: agentStock })

                // dispatch({ type: "UPDATE_AGENTS_STOCKS", payload: list })
                dispatch({ type: "FETCH_COMMERCIAL_STOCKS_FULFILLED", payload:"" })
                console.log("list fetched")
            
            } else {
                dispatch({
                    type: "FETCH_COMMERCIAL_STOCKS_ERROR",
                    payload: list.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_COMMERCIAL_STOCKS_ERROR",
                payload: err
                
            })
        }
    }
}
export function createCommercialRea(newCommercialRea){
    console.log("FIRED ACTION CREATE COMMERCIAL_REA", newCommercialRea)
    return async function(dispatch){
        dispatch({ type: "CREATE_COMMERCIAL_REA_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/new',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:newCommercialRea
                }),
                credentials: 'same-origin',
            }); 
            
            const createdCommercialRea = await response.json()
            console.log(createdCommercialRea)// createdCommercialRea returns new object created

            if(createdCommercialRea.id){ // no errors, return new Object
                dispatch({
                    type:"NEW_COMMERCIAL_REA",
                    payload: createdCommercialRea
                })
                dispatch({ type: "CREATE_COMMERCIAL_REA_FULFILLED", payload:"" })
                
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "CREATE_COMMERCIAL_REA_ERROR",
                    payload: createdCommercialRea.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create rea", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_COMMERCIAL_REA_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteCommercialRea(rea, password = ""){
    return async function(dispatch){
        dispatch({ type: "DELETE_COMMERCIAL_REA_START", payload: "" })
        try {
            const response = await fetch('/stocks/commercial/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data: {
                        ...rea,
                        password: password
                    }
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE COMMERCIAL_REA RESPONSE",{body, status: response.status})

            // Check if there's an error in the response body or if HTTP status indicates error
            if(body.error || !response.ok){ 
                const errorMessage = body.error?.message || body.error || body.message || 'Une erreur est survenue';
                console.error("DELETE_COMMERCIAL_REA_ERROR:", errorMessage);
                dispatch({
                    type: "DELETE_COMMERCIAL_REA_ERROR",
                    payload: errorMessage
                })
                return { success: false, error: errorMessage }; // Return error result
            } else {
                dispatch({ type: "DELETE_COMMERCIAL_REA", payload: rea.id })
                dispatch({ type: "DELETE_COMMERCIAL_REA_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return { success: true }; // Return success result
            }
        } catch (err) {
            console.error("DELETE_COMMERCIAL_REA_EXCEPTION:", err);
            const errorMessage = err.message || 'Une erreur réseau est survenue';
            dispatch({  type: "DELETE_COMMERCIAL_REA_ERROR", payload: errorMessage })
            return { success: false, error: errorMessage }; // Return error result
        }
    }
}

// function sortByDate(list, field = 'date') {
//     // console.log(list);
//     let newList = {}
//     list.sort( (a, b) => {
//         return new Date(b[field]) - new Date(a[field])
//     });

//     list.map( item => {
//         newList[item.id] = item
//     })

//     // console.log('====================================');
//     // console.log({ newList, list});
//     // console.log('====================================');
//     return newList
//   } 